import styled from 'styled-components';

export const Text = styled.p`
  color: ${(props) => props.theme.textColor};
  font-weight: normal;
  font-size: 19px;
  margin-bottom: 8px !important;
`;
